import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
import { useSettingsStore } from './stores/settings-store';
import 'vue3-json-viewer/dist/index.css';

import {
  AppTrackingTransparency,
  AppTrackingStatusResponse,
} from "capacitor-plugin-app-tracking-transparency";
import { BrazeService } from './services';

import { Platform } from 'quasar';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const settingsStore = useSettingsStore();

const showAppTrackingTransparencyCapacitor = async() => {
  try {
    const statusResponse = await AppTrackingTransparency.getStatus();
    if (statusResponse.status === "notDetermined") {
      const requestResponse =
        await AppTrackingTransparency.requestPermission();
      if (requestResponse.status === "authorized") {
        
      }
    }
  } catch (error) {
    console.error("AppTrackingTransparency error:", error);
  }
};

onMounted(async () => {
	settingsStore.updateBrand('Default');
	var id = window.setTimeout(function () {}, 0);

	while (id--) {
		window.clearTimeout(id);
	}

	if(Platform.is.capacitor && Platform.is.ios) {
    // request AppTrackingTransparency , push notification and location permission 
    // one at a time
		showAppTrackingTransparencyCapacitor().then(() => {
			BrazeService.register()?.then(()=>{
				BrazeService.locationPermission();
			});
		});
	}
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, { class: "" }))
}
}

})